import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import Button from '@mui/material/Button';

const HowItWorks = () => {
    const navigate = useNavigate();
    const steps = [
        {
            titulo: "Escolha seu plano.",
            desc: "Escolha o plano que melhor se adapta a você!",
            img: "/assets/howItWorks01.jpg"
        },
        {
            titulo: "Preencha os dados.",
            desc: "Só levará alguns minutos para completar o cadastro.",
            img: "/assets/howItWorks02.jpg"
        },
        {
            titulo: "Selecione o pagamento.",
            desc: "Finalize a contratação e comece a aproveitar nossos serviços.",
            img: "/assets/howItWorks03.jpg"
        },
    ];

    const cardVariants = {
        hidden: { opacity: 0, y: 30 },
        visible: i => ({
            opacity: 1,
            y: 0,
            transition: { delay: i * 0.2, duration: 0.5 }
        }),
    };

    const buttonVariants = {
        hidden: { opacity: 0, scale: 0.8 },
        visible: { opacity: 1, scale: 1, transition: { delay: steps.length * 0.2 + 0.3, duration: 0.4 } },
    };

    return (
        <section
            style={{
                width: "100%",
                height: "fit-content",
                backgroundColor: "#f9f2e4", // bege claro
                padding: "30px",
                boxSizing: "border-box"
            }}
        >
            <div
                style={{
                    width: "100%",
                    textAlign: "center",
                    padding: "0 0 60px",
                }}
            >
                <p style={{ margin: 0 }}>COMO FUNCIONA</p>
                <h1 style={{ fontSize: "clamp(1.0rem, 3vw, 2.2rem)", margin: 0 }}>
                    Contrate em três passos:
                </h1>
            </div>

            <div
                style={{
                    width: "90%",
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: "center",
                    gap: "30px",
                    margin: "0 auto"
                }}
            >
                {steps.map((item, index) => (
                    <motion.div
                        key={index}
                        custom={index}
                        variants={cardVariants}
                        initial="hidden"
                        animate="visible"
                        style={{
                            width: "100%",
                            maxWidth: "300px",
                            flex: "1 1 300px",
                            height: "fit-content",
                            textAlign: "center",
                        }}
                    >
                        <div
                            style={{
                                width: "100%",
                                height: "200px",
                                backgroundColor: "gray",
                                borderRadius: "8px",
                                backgroundImage: `url(${item.img})`,
                                backgroundSize: "cover",
                                backgroundPosition: "center"
                            }}
                        />
                        <div style={{ marginTop: "15px" }}>
                            <h2 style={{ fontSize: "1.2rem", margin: "10px 0" }}>{item.titulo}</h2>
                            <p style={{ fontSize: "0.95rem", margin: 0 }}>{item.desc}</p>
                        </div>
                    </motion.div>
                ))}
            </div>

            <motion.div
                variants={buttonVariants}
                initial="hidden"
                animate="visible"
                style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    padding: "50px 0 20px"
                }}
            >
                <Button
                    variant="contained"
                    onClick={() => {
                        navigate("../planos")
                    }}
                    sx={{
                        padding: "14px 28px",
                        fontSize: "1rem",
                        backgroundColor: "#ffc845", // amarelo
                        color: "#0b243d", // azul marinho
                        borderRadius: "10px",
                        boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
                        transition: "0.3s ease",
                        '&:hover': {
                            backgroundColor: "#e6b53e", // hover do amarelo
                            transform: "scale(1.05)",
                        },
                    }}
                >
                    Escolha um plano
                </Button>
            </motion.div>
        </section>
    );
};

export default HowItWorks;
